module.exports = __webpack_public_path__ + "static/media/vkdonut_donuts_2x.afa1a4d0.png";